module.exports = __webpack_public_path__ + "img/9788957980897.5947bb5c.jpg";